__turbopack_context__.v({
  "change_station_button": "cTsY6q_change_station_button",
  "confirm_station_name": "cTsY6q_confirm_station_name",
  "confirm_station_popup": "cTsY6q_confirm_station_popup",
  "vanish": "cTsY6q_vanish",
});
